export function setToken(token: string): void {
  sessionStorage.setItem("token", token);
}

export function setResponse(response: object): void {
  sessionStorage.setItem("userDetails", JSON.stringify(response));
}

export function getToken(): string | null {
  return sessionStorage.getItem("token");
}

export function getResponse(): object | null {
  const userDetails = sessionStorage.getItem("userDetails");
  return userDetails ? JSON.parse(userDetails) : null;
}

export function removeTokenAndResponse(): void {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("userDetails");
}
